import * as React from 'react';
import type { SVGProps } from 'react';
const IconDragAndDrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconDragAndDrop"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.187 15.712 21.9 12l-3.713-3.712-1.414 1.414L19.071 12l-2.298 2.298zM15.712 18.187l-1.414-1.414L12 19.071l-2.298-2.298-1.414 1.414L12 21.9zM12 4.929l2.298 2.298 1.414-1.414L12 2.1 8.288 5.813l1.414 1.414zM5.813 15.712l1.414-1.414L4.93 12l2.298-2.298-1.414-1.414L2.1 12z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      clipRule="evenodd"
    />
  </svg>
);
export default IconDragAndDrop;
